import React from 'react';
import { Reveal } from './Reveal';
import { CapabilityRow } from './CapabilityRow';
import './Capabilities.scss';

const capabilities = [
  {
    number: '01',
    title: 'Innovation & Product Development',
    desc: "Building digital products end-to-end – from first concept to shipped experience in Boeing's Digital Product Development.",
  },
  {
    number: '02',
    title: 'Strategy & Consulting',
    desc: 'Advising organisations across Asia Pacific on strategic and operational transformation, from financial services to sustainability.',
  },
  {
    number: '03',
    title: 'Entrepreneurship & Venture Building',
    desc: 'Founding and scaling ventures – from idea and market validation through to product-market fit.',
  },
  {
    number: '04',
    title: 'Design & Storytelling',
    desc: 'Crafting narratives, interfaces, and imagery that make complex ideas resonate with real people.',
  },
];

const Capabilities: React.FC = () => {
  return (
    <section id="capabilities" className="capabilities">
      <div className="capabilities__inner section-inner">
        <Reveal className="section-head">
          <h2 className="section-head__label">Capabilities</h2>
          <p className="section-head__statement">
            Four domains, one practice – product, strategy, venture, and craft.
          </p>
        </Reveal>

        <div className="capabilities__list">
          {capabilities.map((cap) => (
            <CapabilityRow key={cap.number} {...cap} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Capabilities;
